import React, { Component } from 'react';

import api from '../../config/api';
import {completeUrlForArticleList, endPage, getDateByLocaleFormat, paginate} from "../../util/utils";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import PaginationButton from "../common/PaginationButton";

class ArticlePage extends Component {

	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.state = {
			defaultSize: 10,
			all: [],
			paginated: [],
			size: 0,
			actual: 1,
			end: 1,
		};
	}

	componentWillMount() {
		const {selectedLanguage} = this.props;
		this.loadArticles(selectedLanguage);
	}

	componentWillReceiveProps(nextProps) {
		const {selectedLanguage, match} = nextProps;
		if(this.props.match.url !== match.url) {
			this.setState({
				defaultSize: 10,
				all: [],
				paginated: [],
				size: 0,
				actual: 1,
				end: 1,
			});
			this.loadArticles(selectedLanguage);
		}
	}

	/**
	 * Load product from API
	 */
	loadArticles = (language) => {
		fetch(api.article(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				// eslint-disable-next-line
				console.log(data);
				const all = completeUrlForArticleList(data);
				const size = all.length;
				this.setState({
					all: all,
					paginated: paginate(all,this.state.defaultSize,1),
					size: size,
					actual: 1,
					end: endPage(all,this.state.defaultSize)
				});
			}).catch(err => console.error(err));
	};

	renderArticleImage = (article) => {
		if(article.image === null){
			return null;
		}
		const style = {
			backgroundImage: "url("+article.image+""
		};
		return <div className="article-item__image" style={style}/>;
	};

	renderArticle = (article, index) => {
		const {localizePath, selectedLanguage} = this.props;
		if(index === 0 || index === 1) {
			return (
				<article className="article-item" key={index}>
					{this.renderArticleImage(article)}
					<h4 className="article-item__title">{article.title}</h4>
					<p className="article-item__prolog">{article.prolog}</p>
					<section className="article-item__bottom">
						<span className="article-item__date">
							{getDateByLocaleFormat(article.createdAt,selectedLanguage.codeCountry)}
						</span>
						<Link className="btn btn-more article-item__btn" to={localizePath("/article/" + article.url)}>
							<FormattedMessage id="home.article.read-more"/>
						</Link>
					</section>
				</article>
			)
		} else {
			return (
				<article className="article-item" key={index}>
					<h4 className="article-item__title">{article.title}</h4>
					{this.renderArticleImage(article)}
					<p className="article-item__prolog">{article.prolog}</p>
					<section className="article-item__bottom">
						<span className="article-item__date">
							{getDateByLocaleFormat(article.createdAt,selectedLanguage.codeCountry)}
						</span>
						<Link className="btn btn-more article-item__btn" to={localizePath("/article/" + article.url)}>
							<FormattedMessage id="home.article.read-more"/>
						</Link>
					</section>
				</article>
			)
		}
	};

	handlePagination = (e, type, next, isDisabled) => {
		if(isDisabled){
			return;
		}

		const page = this.state;
		const size = this.state.defaultSize;

		if(next && page.actual < page.end){
			++page.actual;
		}

		if (!next && page.actual > 1) {
			--page.actual;
		}

		page.paginated = paginate(page.all,size,page.actual);

		this.setState(...page)
	};

	paginationButtonIsDisabled = (type, next) => {
		const page = this.state;
		return page.end < 1  ? true : next ? page.actual === page.end : page.actual === 1;
	};

	render() {
		const {paginated} = this.state;
		return (
			<div className="container-flex">
				<div className="page__banner page__banner--article">
					<h2>
						<FormattedMessage id={"page.title.news"} />
					</h2>
				</div>
				<div className="page">
					<div className="page__content page__content--article">
						<div className="article-list">
							{paginated.map(this.renderArticle)}
						</div>
						<div className="file-list-pagination">
							<PaginationButton
								btnClassName="btn btn-next"
								onClickHandler={this.handlePagination}
								iconClassName="fa fa-angle-left"
								langKey="button.prev.article"
								type="article"
								isDisabled={this.paginationButtonIsDisabled}
								isNext={true}
							/>
							<PaginationButton
								btnClassName="btn btn-prev"
								onClickHandler={this.handlePagination}
								iconClassName="fa fa-angle-right"
								langKey="button.next.article"
								type="article"
								isDisabled={this.paginationButtonIsDisabled}
								isNext={false}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ArticlePage;


// WEBPACK FOOTER //
// ./src/components/page/ArticlePage.js